import React from 'react'
import { Rating as MuiRating, useTheme } from '@mui/material'
import { styled, Theme } from '@mui/material/styles'

interface IRatingProps {
  size?: 'small' | 'medium' | 'large'
  color?: string
  disabled?: boolean
  max?: number
  value?: number
  filledIcon?: JSX.Element
  emptyIcon?: JSX.Element
  onChange?: (_: React.SyntheticEvent<Element, Event>, value: number | null) => void
}

const Rating: React.FC<IRatingProps> = (props) => {
  const theme: Theme = useTheme()
  const StyledRating = styled(MuiRating)({
    '& .MuiRating-iconFilled': {
      color: props.color || theme.palette.secondary.main,
    },
    '& .MuiRating-iconHover': {
      color: props.color || '#e16969',
    },
  })
  return (
    <StyledRating
      name='customized-color'
      defaultValue={3}
      disabled={props.disabled || false}
      value={props.value}
      max={props.max || 5}
      getLabelText={(value: number) => `${value} Heart${value !== 1 ? 's' : ''}`}
      precision={1}
      icon={props.filledIcon}
      emptyIcon={props.emptyIcon}
      onChange={(_, value) => props.onChange && props.onChange(_, value)}
      size={props.size || 'medium'}
    />
  )
}
export default Rating
